/* eslint-disable no-new-object */

import { WIZARD } from "redux/constants/action-types";

export function UpdateCampaignID(payload) {
  return async function (dispatch) {
    try {
      dispatch({
        type: WIZARD.UPDATE_CAMPAIGN_ID,
        payload,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}
export function UpdateAudience(payload) {
  return async function (dispatch) {
    try {
      dispatch({
        type: WIZARD.UPDATE_AUDIENCE_ID,
        payload,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}
export function UpdateDesignID(payload) {
  return async function (dispatch) {
    try {
      dispatch({
        type: WIZARD.UPDATE_DESIGN_ID,
        payload,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ClearAllWizard() {
  return async function (dispatch) {
    try {
      dispatch({
        type: WIZARD.CLEAR_ALL_WIZARD
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function UpdateCampaignAudienceDesign(payload) {
  return async function (dispatch) {
    try {
      dispatch({
        type: WIZARD.UPDATE_CAMPAIGN_AUDIENCE_DESIGN,
        payload,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function UpdateCampaignOldDesign(payload) {
  return async function (dispatch) {
    try {
      dispatch({
        type: WIZARD.UPDATE_CAMPAIGN_OLDDESIGN_ID,
        payload,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}